import React from 'react'
import FeedbackCompleto from '../../../../components/performance/FeedbackCompleto'

export default function FeedbackCompletePage() {
  return (
    
            <FeedbackCompleto />
          
  )
}
